import { useTranslation } from "react-i18next";

import { ChildOverviewProps } from "./types";
import {
  AddressDisplay,
  SectionHeader,
} from "../../../../../components/FormControls";

export const ChildResidenceSection = ({
  childDetails,
  fetchedData,
  canApply,
}: ChildOverviewProps) => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        title={t("person.permanentResidenceInformation")}
        subtitle={t("person.mupSource")}
      />
      <AddressDisplay
        address={childDetails.residence?.permanentAddress}
        fetchedAddress={fetchedData?.residence?.permanentAddress}
        canApply={canApply}
        title={t("person.permanentResidenceInformation")}
      />
    </>
  );
};
